import React from "react";
import styles from "./promotedContent.module.scss";
import cx from "classnames";
import { Media } from "../../../../types/media";
import Button from "src/components/button";
import _ from "lodash";
import { Asset } from "src/types/assets";
import { Stream } from "src/types/streams";
import { Collection } from "src/types/collections";

const DefaultAssetIcon = '/images/defaultIcons/default_asset.jpg'
const DefaultBackground = '/images/defaultIcons/DefaultBackground.jpeg'

const MediaRenderer = ({ icon }: { icon?: Media }) => {
  if (!icon) return null;

  const { type, full, thumbnail } = icon;

  if (type === "image") {
    return <img src={full} className={styles.thumbnail} alt="stream icon" />;
  }

  if (type === "video") {
    return (
      <video
        autoPlay
        playsInline
        muted
        loop
        key={thumbnail}
        className={styles.thumbnail}
      >
        <source src={full} type="video/mp4" />
      </video>
    );
  }

  return null;
};

interface PromotedContentCardProps {
  id: string;
  icon: Media;
  name?: string;
  description?: string;
  item?: Asset | Collection | Stream;
}

// Main contentCard component
export function PromotedContentCard({
  icon,
  name,
  description,
  item
}: PromotedContentCardProps) {

  var parsedDescription = description || "";
  const isCollection = item?.entityType === "collection";
  if(isCollection){
    const placeholders = {
      '{{collection.name}}': _.get(item,"name"),
      '{{collection.assets}}': _.size(_.get(item,"sections")) > 0 ? "" : _.get(item,"assetsCount"),
      '{{contact.firstname}}': '',
      '{{contact.lastname}}': '',
      '{{contact.company}}': ''
    };


    for (const placeholder in placeholders) {
      const value = placeholders[placeholder];
      parsedDescription = parsedDescription.split(placeholder).join(value);
    }
  }

  const contentIcon: Media = icon || {
    id: "",
    type: 'image',
    full: isCollection ? DefaultBackground : DefaultAssetIcon,
    thumbnail: isCollection ? DefaultBackground : DefaultAssetIcon
  };
 
  return (
    <div className={styles.content}>
      <div className={styles.contentIcon}>
        <MediaRenderer icon={contentIcon} />
      </div>
      <div className={styles.contentDetails}>
        <p className={styles.contentName}>{name}</p>
        {_.size(parsedDescription) > 0 && <p className={styles.contentDescription}>
          {parsedDescription
            ? parsedDescription.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ")
            : ""}
        </p>} 
        <Button
          text="explore"
          variant="tertiary"
          className={styles.button}
          icon="paperflite-right-arrow"
        />
  
      </div>
    </div>
  );
}

// Placeholder version of contentCard
export function PlaceholderPromotedContentCard() {
  return (
    <div className={cx(styles.content, styles.block, styles.placeholder)}>
      <div className={cx(styles.contentIcon, styles.block)}></div>
      <div className={cx(styles.contentDetails)}>
        <p className={cx(styles.contentName, styles.block)}></p>
        <p className={cx(styles.contentDescription, styles.block)}></p>
      </div>
    </div>
  );
}
